import React from 'react';
import { HiH2 } from 'react-icons/hi2';

const HeroSection = ({ colors, handleContactClick, scrollToIntro }) => {
  return (
    <section className="position-relative overflow-hidden performance-optimized hero-section-mobile" style={{
      Height: '100vh',
      backgroundColor: colors.bodyBlack,
      color: colors.white,
      paddingBottom: '130px'
    }}>
      <video 
        className="position-absolute w-100 h-100 video-slide-in"
        style={{
          objectFit: 'cover',
          zIndex: 0
        }}
        autoPlay
        loop
        muted
        playsInline
      >
        <source src="https://cdn.pixabay.com/video/2023/07/21/172529-847499878_tiny.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      
      <div className="position-absolute w-100 h-100 video-overlay-animate" style={{
        background: `linear-gradient(135deg, rgba(${colors.primaryRgb}, 0.8), rgba(26, 26, 26, 0.8))`,
        zIndex: 1
      }}></div>
      
      <div className="container position-relative" style={{zIndex: 2}}>
        <div className="row align-items-center">
          <div className="col-lg-6">
            <h1 className="display-4 fw-bold mb-4 hero-title hero-title-mobile" style={{ color: colors.white }}>
              About IDLBAY
            </h1>
            <h2 className="lead mb-4 hero-description hero-description-mobile" style={{ color: colors.white }}>
              IDLBAY Private Limited delivers innovative IT solutions that drive efficiency, growth, and digital transformation for businesses of all sizes. We are your trusted partner for cutting-edge software solutions that empower businesses with technology.
            </h2>
            <div className="d-flex gap-3 hero-buttons hero-buttons-mobile">
              <button 
                className="btn btn-lg px-4 d-flex align-items-center gap-2 btn-animated hero-button-mobile" 
                style={{ 
                  backgroundColor: `var(--color-primary)`,
                  color: colors.white,
                  border: 'none'
                }}
                onClick={handleContactClick}
              >
                Meet Team
              </button>
              <button 
                className="btn btn-lg px-4 d-flex align-items-center gap-2 btn-animated hero-button-mobile"
                style={{
                  backgroundColor: 'transparent',
                  color: colors.white,
                  border: `2px solid ${colors.white}`
                }}
                onClick={scrollToIntro}
              >
                Learn More
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;